import { Button, Modal, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import liracrypt from './Liracrypt/liracrypt';
import { useSelector } from 'react-redux';
import { createRoute } from '../utils/CustomFunc';
import noImg from '../assets/static/noImg.jpeg'
import ZenModal from './ZenModal';
import {
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    DownloadOutlined,
    AuditOutlined,
    ProfileOutlined,
    FileDoneOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    PieChartOutlined,
    BarChartOutlined,
    ApartmentOutlined,
    EllipsisOutlined,
    HolderOutlined,
    MenuOutlined,
    RightSquareOutlined,
    LeftSquareOutlined,
    MenuUnfoldOutlined,
    BarcodeOutlined
} from "@ant-design/icons";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const ZenActionBtn = ({
    actionBtns,
    style = {}
}) => {

    const icons = {
        EllipsisOutlined,
        HolderOutlined,
        MenuOutlined,
        EditOutlined,
        DeleteOutlined,
        EyeOutlined,
        LoadingOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        DownloadOutlined,
        AuditOutlined,
        ProfileOutlined,
        FileDoneOutlined,
        UpSquareOutlined,
        DownSquareOutlined,
        PieChartOutlined,
        BarChartOutlined,
        ApartmentOutlined,
        RightSquareOutlined,
        LeftSquareOutlined,
        MenuUnfoldOutlined,
        BarcodeOutlined
    }
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();

    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });

    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }


    const zenPopupAction = (zenPopup) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        // if (zenPopup?.props) {
        //     urlData[zenPopup?.props] = value;
        // }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    //    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');

                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (zenPop) => {
        if (zenPop) {
            setZenModal(zenPop);
            if (zenPop?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPop.params };
                if (zenPop?.api) {
                    zenParams.api = zenPop?.api;
                }
                let route = createRoute({
                    props: zenPop?.props,
                    record: {},
                    multiProps: zenPop?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPop?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPop?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPop?.onOk?.params };
                // if (zenPop?.onOk?.multiProps) {
                //     zenPop?.onOk?.multiProps.forEach((prop) => {
                //         urlData[prop] = record[prop];
                //     });
                // };
                // if (zenPop?.onOk?.props) {
                //     urlData[zenPop?.onOk?.props] = record[zenPop?.onOk?.props];
                // }

                Modal.confirm({
                    title: zenPop?.text,
                    okText: zenPop?.okButtonText,
                    cancelText: zenPop?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPop?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPop)

        }
    }

    return (
        <>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
            {/* <div style={{...style }} onClick={onColumnClick}>
                <span>{label}</span>
            </div> */}
            <div style={{ minHeight: 40, alignItems: 'center', border: '1px solid #9c9c9c', display: 'inline-flex', justifyContent: 'center', width: '100%', flexWrap: 'wrap' }}>
                {
                    actionBtns.length ?
                        actionBtns.map((x, i) => (
                            <div key={`dynamic-action-btn-${i}`}>
                                <Tooltip placement="bottom" title={x.toolTip || 'Action'}>
                                    <IconComponent
                                        icon={icons[x.icon]}
                                        onClick={() => onColumnClick(x.zenPop)}
                                        style={x.iconStyle}
                                    />
                                </Tooltip>
                            </div>
                        )) : <></>
                }
            </div>
        </>

    )
};

export default ZenActionBtn;